var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPromotion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "leftmenu/other/icon-promotion") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "1.33055874e-13%",
    x2: "50%",
    y2: "104.53891%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb61a",
    stopOpacity: 0.7,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb61a",
    stopOpacity: 0.995478029,
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb61a",
    stopOpacity: 0.995478029,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.0997603,11.3545918 L15.6027146,11.3545918 L15.6027146,15.8826531 L24.8747118,15.8826531 L24.8747118,15.8826531 L25.0997603,15.8826531 C25.599868,15.8826531 26,15.4852826 26,14.9996075 L26,12.2376374 C26.0049553,11.7519623 25.599868,11.3545918 25.0997603,11.3545918 Z M3,12.2425432 L3,15.0045133 C3,15.4901884 3.40508726,15.8875589 3.9001939,15.8875589 L4.12524238,15.8875589 L4.12524238,15.8875589 L13.3972396,15.8875589 L13.3972396,11.3594527 L3.9001939,11.3594527 C3.40008618,11.3545918 3,11.7519623 3,12.2425432 Z M15.6027146,28 L23.2093531,28 C24.1295513,28 24.8747118,27.2690345 24.8747118,26.3663658 L24.8747118,18.2963108 L15.6027146,18.2963108 L15.6027146,28 L15.6027146,28 Z M4.12524238,26.3663658 C4.12524238,27.2690345 4.87040288,28 5.7906011,28 L13.3972396,28 L13.3972396,18.2963108 L4.12524238,18.2963108 L4.12524238,26.3663658 L4.12524238,26.3663658 Z M7.85604599,9.68661695 C8.33614941,9.91228414 9.0613056,10.0202119 10.1165329,10.0349294 L10.1165329,10.0398352 L18.4483276,10.0398352 L18.4483276,10.0398352 C18.5283448,10.0398352 18.608362,10.0398352 18.6883793,10.0398352 L18.6883793,10.0398352 C19.8636324,10.0398352 20.6538026,9.92700157 21.1689136,9.68661695 C22.9542982,8.85753532 23.7144619,6.75294349 22.8692798,5.00647567 C22.2791527,3.78492936 21.0088791,3 19.6285818,3 C19.0934665,3 18.5783556,3.11283359 18.0932511,3.33850078 C17.0230206,3.83889325 15.5727082,5.76687598 14.5074787,7.35635793 C13.6122859,6.01707221 12.0419476,3.86342229 10.9217063,3.33850078 C10.4366018,3.11283359 9.92149089,3 9.38637562,3 C8.01107939,3 6.74080577,3.78983516 6.14567758,5.00647567 C5.31049768,6.75294349 6.07066142,8.85262951 7.85604599,9.68661695 Z M18.8234084,4.82496075 C19.0834644,4.70722135 19.3535225,4.64344584 19.6385839,4.64344584 C20.3687412,4.64344584 21.0438867,5.06043956 21.3589545,5.70800628 C21.8090515,6.63520408 21.4039642,7.75372841 20.4587606,8.19034537 C20.3637401,8.23449765 19.9486507,8.3816719 18.6983814,8.3816719 C17.7681811,8.3816719 16.7179548,8.29827316 15.947789,8.22468603 C16.9029947,6.80690738 18.1932726,5.11930926 18.8234084,4.82496075 Z M7.67600721,5.71291209 C7.99107508,5.06534537 8.6662205,4.64835165 9.39637778,4.64835165 C9.6764381,4.64835165 9.95149735,4.70722135 10.2115534,4.82986656 C10.8416891,5.12421507 12.131967,6.81181319 13.0921739,8.23449765 C12.322008,8.30808477 11.2767828,8.39148352 10.3415814,8.39148352 C9.09131207,8.39148352 8.67622266,8.24430926 8.58120219,8.20015699 C7.63099752,7.75372841 7.22591026,6.64010989 7.67600721,5.71291209 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-17.4%",
    y: "-8.0%",
    width: "134.8%",
    height: "132.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "leftmenu/other/icon-promotion",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPromotion);
export default __webpack_public_path__ + "static/media/icon-promotion.b02b5acd4e2ec4551833d5b5b2b8f01e.svg";
export { ForwardRef as ReactComponent };